import React from 'react';
import './App.css';
import Note from './Note';

function Board(props) {

    const [notes, setNotes] = React.useState([]);
    React.useEffect(() => {
        getNotes(props.count);
    }, [props.count]);
    const [uniqueId, setUniqueId] = React.useState(props.count);
    
    async function getNotes(count) {

        // Sanity check count
        if (typeof count !== "number") {
            return new Error("board count must be a number");
        }
        if (count > 100) {
            return new Error("currently can only create 100 notes");
        }

        // Now fetch the requested number of 'notes'
        let url = `https://baconipsum.com/api/?type=all-meat&sentences=${count}`;
        let urlNotes = [];
        let response, json;
        try {
            response = await fetch(url);
            json = await response.json();
        } catch(err) {
            console.log("Couldn't connect to the Bacon API: ", err);
            return;
        }
        json[0].split(". ").forEach(
            (sentence, index) => urlNotes.push(
               {
                   id: index,
                   note: sentence
               }
            )
        );
        setNotes(urlNotes);            
    }

    function nextId() {
        setUniqueId(uniqueId => ( uniqueId + 1 ));
        return uniqueId;
    }

    function add(text) {
        setNotes([...notes,
            {
                id: nextId(),
                note: text
            }
        ]);
    }

    function update(newText, id) {
        const updatedNotes = notes.map(
            note => (note.id !== id) ?
                note :
                {
                    ...note,
                    note: newText
                }
        );
        setNotes(updatedNotes);
    }

    function remove(id) {
        const updatedNotes = notes.filter(
            note => (note.id !== id)
        )
        setNotes(updatedNotes);
    }

    function eachNote(note) {
        return (
            <Note
                key={note.id}
                id={note.id}
                onChange={update}
                onRemove={remove}>
                {note.note}
            </Note>
        );
    }

    return (
        <div className="board">
            {notes.map(eachNote)}
            <button onClick={() => add("New Note")}>+</button>
        </div>
    );
}

export default Board;
